import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#71AE52",
        secondary: "#005380",
        accent: "#07C730",
        error: "#FF0048",
        info: "#71AE52",
        success: "#07C730",
        warning: "#2BA681",
        leftPanel: "#E8E7E8",
        rightPanel: "#ffffff",
        textColor: "#000000",
        textColorLeft: "#000000",
        spec: "#003895",
      },
      dark: {
        primary: "#71AE52",
        secondary: "#005380",
        accent: "#07C730",
        error: "#FF0048",
        info: "#71AE52",
        success: "#07C730",
        warning: "#2BA681",
        leftPanel: "#566361",
        rightPanel: "#000000",
        textColor: "#ffffff",
        textColorLeft: "#ffffff",
        spec: "#FFEA00",
      },
    },
  },
});
